import React, { useState } from 'react';
import { twMerge } from 'tailwind-merge';
type NumberFieldProps = {
  ariaLabel: string;
  value: number;
  decimals?: number;
  unit?: string;
  step?: number;
  min?: number;
  max?: number;
  disabled?: boolean;
  onChange?: (value: number) => void;
  className?: string;
};
export function NumberField({
  ariaLabel,
  value,
  decimals = 2,
  unit,
  step = 0.1,
  min = 0,
  max = 9999,
  disabled = false,
  onChange,
  className
}: NumberFieldProps) {
  const [internal, setInternal] = useState(value);
  const [draft, setDraft] = useState<string | null>(null);
  const current = onChange ? value : internal;
  const commit = (next: number) => {
    const clamped = Math.min(max, Math.max(min, Number.isFinite(next) ? next : current));
    const rounded = Number(clamped.toFixed(decimals));
    if (onChange) onChange(rounded);else setInternal(rounded);
  };
  return <div className={twMerge('flex h-[24px] w-[84px] items-center rounded-[4px] border border-pf-line bg-white pl-2 pr-[3px] text-[12px] text-pf-ink', disabled && 'bg-[#eceef0] text-pf-faint', className)} data-id="element-849" data-mp="mgzbzaga07yw">
      
      <input aria-label={ariaLabel} disabled={disabled} inputMode="decimal" value={draft ?? current.toFixed(decimals)} onChange={e => setDraft(e.target.value)} onBlur={() => {
      if (draft !== null) commit(parseFloat(draft));
      setDraft(null);
    }} onKeyDown={e => {
      if (e.key === 'Enter') (e.target as HTMLInputElement).blur();
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        commit(current + step);
      }
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        commit(current - step);
      }
    }} className="min-w-0 flex-1 bg-transparent text-right outline-none disabled:cursor-not-allowed" data-id="element-850" data-mp="19wi66vtyxcm6" />
      
      {unit && <span className="ml-[3px] shrink-0" data-id="element-851" data-mp="89hegus1q9hz">{unit}</span>}
      <div className="ml-[4px] flex flex-col gap-[2px]" data-id="element-852" data-mp="1bjmwvqvncrr5">
        <button type="button" tabIndex={-1} aria-label={`Increase ${ariaLabel}`} disabled={disabled} onClick={() => commit(current + step)} className="text-[#6b7076] hover:text-pf-ink disabled:text-pf-faint" data-id="element-853" data-mp="1bm92hkyz8x6q">
          
          <svg viewBox="0 0 8 5" className="h-[4px] w-[7px]" fill="currentColor" data-id="element-854" data-mp="1fk6tmtcb5tcr">
            <path d="M4 0 L8 5 H0 Z" data-id="element-855" data-mp="1uhpomdfkx2sn" />
          </svg>
        </button>
        <button type="button" tabIndex={-1} aria-label={`Decrease ${ariaLabel}`} disabled={disabled} onClick={() => commit(current - step)} className="text-[#6b7076] hover:text-pf-ink disabled:text-pf-faint" data-id="element-856" data-mp="1pkfskexopsvu">
          
          <svg viewBox="0 0 8 5" className="h-[4px] w-[7px]" fill="currentColor" data-id="element-857" data-mp="2d9i89h8rdbnp">
            <path d="M0 0 H8 L4 5 Z" data-id="element-858" data-mp="2d75qp56wx3b6" />
          </svg>
        </button>
      </div>
    </div>;
}